import {
    // COMMON
    Add, AddBox, AddCircle, AddCircleOutline, AddCircleOutlineOutlined, Analytics, AnalyticsOutlined, ChevronRight, Clear, Close,
    ArrowBack, ArrowDownward, ArrowDropDown, ArrowDropUp, ArrowForward, ArrowRight,
    CheckCircle, ChevronLeft, KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight,
    KeyboardArrowUp, ArrowUpward, Comment, Delete, DeleteForever, DeleteOutlined,
    DoNotDisturb, Download, DownloadForOffline, DownloadOutlined, Downloading, Edit,
    EditOutlined, RadioButtonChecked, RadioButtonUnchecked, Filter, FilterAltOffRounded,
    FilterAltRounded, ViewList, Cancel, Check, CheckBox, CheckBoxOutlineBlank, OpenInNew,
    Visibility, VisibilityOff, Error, GridView, Info, InsertDriveFile, Remove, RemoveCircle,
    CalendarMonthOutlined, Search, Reply, Block, CenterFocusStrongOutlined, DeviceHub,
    DragIndicator, Folder, KeyboardVoice, PeopleAlt, PortraitOutlined, PortraitRounded,
    RateReview, Segment, Send, SplitscreenRounded, Stop, Subscriptions, SubscriptionsOutlined,
    SupervisedUserCircle, SupervisedUserCircleOutlined, TableRows, ThumbDown, ThumbDownOutlined,
    ThumbUp, ThumbUpOutlined, UploadFile, Videocam, Warning, Wc, ZoomIn, ZoomOut,
    GraphicEqRounded,

    // SIDE DRAWER ICONS
    Api, ApiOutlined, Announcement, AnnouncementOutlined, Dashboard, DashboardOutlined,
    Assignment, AssignmentOutlined, Badge, BadgeOutlined, Category, CategoryOutlined,
    Description, DescriptionOutlined, DeveloperMode, DeveloperModeOutlined, OndemandVideo,
    OndemandVideoOutlined, ManageAccounts, ManageAccountsOutlined, Lock, LockOutlined,
    EmojiPeople, EmojiPeopleOutlined, Settings, SettingsOutlined, QuestionMark,
    QuestionMarkOutlined, Quiz, QuizOutlined, FiberManualRecord, FiberManualRecordOutlined,
    Home, HomeOutlined, Insights, InsightsOutlined, DynamicForm, DynamicFormOutlined,
    Feedback, FeedbackOutlined, NewReleases, NotificationsActiveOutlined, Rule, RuleOutlined,
    School, SchoolOutlined, PsychologyAlt, PsychologyAltOutlined, Replay, QuestionAnswer,
    QuestionAnswerOutlined, VideocamOutlined, ViewColumnOutlined, Terminal, TerminalOutlined,
    ViewQuilt, ViewQuiltOutlined, PlayCircleFilledWhite, PlayCircleFilledWhiteOutlined,
    AutoStories, AutoStoriesOutlined, LiveHelp, LiveHelpOutlined, CoPresentOutlined, CoPresent,


    // VIDEO PLAYER
    Forward10, VolumeDown, VolumeOff, VolumeUp, Pause, PlayArrow, Fullscreen, FullscreenExit,
    Replay10, Logout, SupportAgent, SupportAgentOutlined, DataObject, MeetingRoom, MeetingRoomOutlined,
    PersonRemove, PersonAdd, Login, OpenInFull, PushPin, PushPinOutlined, HighlightAlt, Workspaces,
    LoginOutlined, Code, BugReport, ExpandLess, ExpandMore,
    CancelPresentation, PresentToAll, MemoryOutlined, AccessTime, Cached, Groups, Groups2, FormatClear,
    Publish, MicOff, VideocamOff, MoreVert, EmojiEmotions, Mic, FrontHand, FrontHandOutlined, Checklist,
    AutoFixHigh, FilePresent, PaletteOutlined, DarkMode, LightMode, ComputerOutlined, SwapVertSharp,
    TrendingUp, Sync, Money, Scoreboard, LastPage, Menu, Person, Class, ClassOutlined, CopyAll,
    AdsClick, DomainAdd, UnfoldMore, Archive, Link, SpeakerNotes, CloudUploadOutlined, Group,
    Pets, Whatshot, History, Pending, TipsAndUpdates, FileUpload, TextFields, Movie,
    AccountBalance, AccountTree, AdminPanelSettings, AdminPanelSettingsOutlined, Sort, ArrowOutward,
    Storage, TheaterComedy, TheaterComedyOutlined, Dvr, DvrOutlined, MenuOpenOutlined,
    Campaign, ReportOutlined, Share, Ballot, ChatBubble, CastForEducation, CastForEducationOutlined,
    Cast, CastConnected, Devices, CheckCircleOutlined, SignalCellularAlt, Speed, Wifi, Engineering,
    EngineeringOutlined, EmojiEvents,
    Business,
    StairsOutlined,
    FormatListBulleted,
    BugReportOutlined,
    LinkOff,
    BrokenImage,
    PlaylistAdd,
    Notes,
    LockOpenOutlined,
    Public,
    SwitchAccessShortcut,
    Swipe,
    Apps,
    Science,
    Memory,
    Stars,
    BookmarkBorder,
    Bookmark,
    Bookmarks,
    PlaylistAddCheckCircleOutlined,
    LibraryBooksOutlined,
    LibraryBooks,
    CollectionsBookmark,
    CollectionsBookmarkOutlined,
    Book,
    BookOutlined,
    Language,
    LinkedIn,
    GitHub,
    LocationSearching,
    PictureAsPdf,
    ContactMail,
    ContactMailOutlined,

    // Icons only present in alive-academics/utils/utilities.js
    Height,
    Crop169,
    CropPortrait,
    CropLandscape,
    CropSquare,
    RocketLaunch,
    Image,

} from '@mui/icons-material'
import { CrownIcon, DocumentIcon, MaterialIcon, PDFIcon, SubjectIcon, VideoIcon } from '../assets/custom-icons'

const FileIcon = (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8.89028 30.3569H23.1131C25.8857 30.3569 27.2651 28.9643 27.2651 26.1649V5.84772C27.2651 3.06201 25.8857 1.64258 23.1131 1.64258H8.89028C6.13142 1.64258 4.73828 3.06201 4.73828 5.84829V26.1649C4.73828 28.9637 6.13142 30.3569 8.89028 30.3569ZM8.99714 28.2009C7.61771 28.2009 6.89428 27.4637 6.89428 26.1249V5.88829C6.89428 4.56258 7.61771 3.79858 9.01085 3.79858H23.0063C24.3989 3.79858 25.1091 4.54886 25.1091 5.88829V26.1249C25.1091 27.4637 24.3989 28.2009 23.0194 28.2009H8.99714ZM10.9394 9.39686H21.0909C21.5594 9.39686 21.9211 9.02201 21.9211 8.55344C21.9211 8.09801 21.56 7.75001 21.0909 7.75001H10.9394C10.4434 7.75001 10.0954 8.09801 10.0954 8.55344C10.0954 9.02201 10.444 9.39686 10.9394 9.39686ZM10.9394 14.0711H21.0909C21.5594 14.0711 21.9211 13.6963 21.9211 13.2272C21.9211 12.7723 21.56 12.4237 21.0909 12.4237H10.9394C10.4434 12.4237 10.0954 12.7723 10.0954 13.2272C10.0954 13.6957 10.444 14.0711 10.9394 14.0711ZM10.9394 18.7454H15.7474C16.216 18.7454 16.5777 18.3837 16.5777 17.9283C16.5777 17.4597 16.216 17.098 15.7474 17.098H10.9389C10.4429 17.098 10.0949 17.4597 10.0949 17.9283C10.0949 18.3837 10.4434 18.7454 10.9389 18.7454' fill='currentColor' />
    </svg>
)

const iconProps = {
    sx: {
        color: "inherit", fontSize: "inherit"
    }
}

export const Icons = {}
Icons.default = {
    Image: <Image  {...iconProps} />,
    ContactMail: <ContactMail  {...iconProps} />,
    ContactMailOutlined: <ContactMailOutlined  {...iconProps} />,
    PictureAsPdf: <PictureAsPdf  {...iconProps} />,
    LocationSearching: <LocationSearching  {...iconProps} />,
    LinkedIn: <LinkedIn  {...iconProps} />,
    GitHub: <GitHub  {...iconProps} />,
    Language: <Language  {...iconProps} />,
    BookOutlined: <BookOutlined  {...iconProps} />,
    Book: <Book  {...iconProps} />,
    CollectionsBookmarkOutlined: <CollectionsBookmarkOutlined  {...iconProps} />,
    CollectionsBookmark: <CollectionsBookmark  {...iconProps} />,
    LibraryBooksOutlined: <LibraryBooksOutlined  {...iconProps} />,
    LibraryBooks: <LibraryBooks  {...iconProps} />,
    PlaylistAddCheckCircleOutlined: <PlaylistAddCheckCircleOutlined  {...iconProps} />,
    BookmarkBorder: <BookmarkBorder  {...iconProps} />,
    Bookmark: <Bookmark  {...iconProps} />,
    Bookmarks: <Bookmarks  {...iconProps} />,
    Stars: <Stars  {...iconProps} />,
    Memory: <Memory  {...iconProps} />,
    Science: <Science  {...iconProps} />,
    Apps: <Apps  {...iconProps} />,
    Swipe: <Swipe  {...iconProps} />,
    SwitchAccessShortcut: <SwitchAccessShortcut  {...iconProps} />,
    Public: <Public  {...iconProps} />,
    LockOpenOutlined: <LockOpenOutlined  {...iconProps} />,
    Notes: <Notes  {...iconProps} />,
    PlaylistAdd: <PlaylistAdd  {...iconProps} />,
    BrokenImage: <BrokenImage  {...iconProps} />,
    LinkOff: <LinkOff  {...iconProps} />,
    BugReportOutlined: <BugReportOutlined  {...iconProps} />,
    FormatListBulleted: <FormatListBulleted  {...iconProps} />,
    StairsOutlined: <StairsOutlined  {...iconProps} />,

    // Keys only present in alive-academics/utils/utilities.js
    RocketLaunch: <RocketLaunch  {...iconProps} />,
    CropSquare: <CropSquare  {...iconProps} />,
    CropLandscape: <CropLandscape  {...iconProps} />,
    CropPortrait: <CropPortrait  {...iconProps} />,
    Crop169: <Crop169  {...iconProps} />,
    Height: <Height  {...iconProps} />,
    FileIcon,
    Crown: <img {...iconProps} src={CrownIcon} alt='Crown' />,
    Subject: <img {...iconProps} src={SubjectIcon} alt='Subject' />,
    Material: <img {...iconProps} src={MaterialIcon} alt='Material' />,
    Document: <img {...iconProps} src={DocumentIcon} alt='Document' />,
    PDF: <img {...iconProps} src={PDFIcon} alt='pdf' />,
    Video: <img {...iconProps} src={VideoIcon} alt='video' />,

    // Keys present in both files (identical) - listed once
    Business: <Business  {...iconProps} />,
    EmojiEvents: <EmojiEvents  {...iconProps} />,
    SpeedIcon: <Speed  {...iconProps} />,
    Wifi: <Wifi  {...iconProps} />,
    EngineeringOutlined: <EngineeringOutlined  {...iconProps} />,
    Engineering: <Engineering  {...iconProps} />,
    ReportOutlined: <ReportOutlined  {...iconProps} />,
    AnnouncementMic: <Campaign  {...iconProps} />,
    Devices: <Devices {...iconProps} />,
    Stream: <Cast {...iconProps} />,
    Streamimg: <CastConnected {...iconProps} />,
    HybridClasses: <CastForEducation {...iconProps} />,
    HybridClassesOutlined: <CastForEducationOutlined {...iconProps} />,
    ChatBubble: <ChatBubble {...iconProps} />,
    Ballot: <Ballot  {...iconProps} />,
    Share: <Share  {...iconProps} />,
    Storage: <Storage  {...iconProps} />,
    ArrowOutward: <ArrowOutward  {...iconProps} />,
    Sort2: <Sort  {...iconProps} />,
    MenuClose: <MenuOpenOutlined  {...iconProps} />,
    AdminActivity: <Dvr  {...iconProps} />,
    AdminActivityOutlined: <DvrOutlined  {...iconProps} />,
    Impersonation: <TheaterComedy  {...iconProps} />,
    ImpersonationOutlined: <TheaterComedyOutlined  {...iconProps} />,
    ModulePermissions: <AdminPanelSettings  {...iconProps} />,
    ModulePermissionsOutlined: <AdminPanelSettingsOutlined  {...iconProps} />,
    Branches: <AccountTree  {...iconProps} />,
    Building1: <AccountBalance  {...iconProps} />,
    SupervisedUserCircle: <SupervisedUserCircle  {...iconProps} />,
    Movie: <Movie  {...iconProps} />,
    Upload: <FileUpload {...iconProps} />,
    AskAI: <TipsAndUpdates {...iconProps} />,
    Pending: <Pending {...iconProps} />,
    History: <History {...iconProps} />,
    Trending2: <Whatshot {...iconProps} />,
    Simba: <Pets {...iconProps} />,
    People: <Group {...iconProps} />,
    QuizModule: <SpeakerNotes {...iconProps} />,
    CloudUpload: <CloudUploadOutlined {...iconProps} />,
    File: <InsertDriveFile {...iconProps} />,
    Text: <TextFields  {...iconProps} />,
    RemoveFormat: <FormatClear  {...iconProps} />,
    Archive: <Archive {...iconProps} />,
    Link: <Link {...iconProps} />,
    UnfoldMore: <UnfoldMore {...iconProps} />,
    DomailAdd: <DomainAdd {...iconProps} />,
    Click: <AdsClick {...iconProps} />,
    Copy: <CopyAll {...iconProps} />,
    Class: <Class {...iconProps} />,
    ClassOutlined: <ClassOutlined {...iconProps} />,
    User: <Person {...iconProps} />,
    Menu: <Menu {...iconProps} />,
    Last: <LastPage {...iconProps} />,
    ScoreBoard: <Scoreboard {...iconProps} />,
    Money: <Money {...iconProps} />,
    Sync: <Sync {...iconProps} />,
    TrendingUp: <TrendingUp {...iconProps} />,
    Group: <Groups  {...iconProps} />,
    Sort: <SwapVertSharp {...iconProps} />,
    Clock: <AccessTime {...iconProps} />,
    SystemTheme: <ComputerOutlined   {...iconProps} />,
    DarkMode: <DarkMode   {...iconProps} />,
    LightMode: <LightMode   {...iconProps} />,
    PaletteOutlined: <PaletteOutlined  {...iconProps} />,
    FilePresent: <FilePresent {...iconProps} />,
    MoreVert: <MoreVert {...iconProps} />,
    PresentToAll: <PresentToAll {...iconProps} />,
    EmojiEmotions: <EmojiEmotions {...iconProps} />,
    Mic: <Mic {...iconProps} />,
    FrontHand: <FrontHand {...iconProps} />,
    FrontHandOutlined: <FrontHandOutlined {...iconProps} />,
    Checklist: <Checklist {...iconProps} />,
    AutoFixHigh: <AutoFixHigh {...iconProps} />,
    Publish: <Publish {...iconProps} />,
    CancelPresentation: <CancelPresentation {...iconProps} />,
    MicOff: <MicOff {...iconProps} />,
    VideocamOff: <VideocamOff {...iconProps} />,
    OpenInFull: <OpenInFull {...iconProps} />,
    PushPin: <PushPin {...iconProps} />,
    PushPinOutlined: <PushPinOutlined {...iconProps} />,
    PersonAdd: <PersonAdd {...iconProps} />,
    PersonRemove: <PersonRemove {...iconProps} />,
    Login: <Login {...iconProps} />,
    Info: <Info {...iconProps} />,
    MeetingRooms: <MeetingRoom {...iconProps} />,
    MeetingRoomsOutlined: <MeetingRoomOutlined {...iconProps} />,
    CodeLab: <DataObject {...iconProps} />,
    GraphicEqRounded: <GraphicEqRounded {...iconProps} />,
    SupportAgent: <SupportAgent {...iconProps} />,
    SupportAgentOutlined: <SupportAgentOutlined {...iconProps} />,
    Logout: <Logout {...iconProps} />,
    Terminal: <Terminal {...iconProps} />,
    TerminalOutlined: <TerminalOutlined {...iconProps} />,
    ZoomIn: <ZoomIn {...iconProps} />,
    ZoomOut: <ZoomOut {...iconProps} />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined {...iconProps} />,
    Announcement: <Announcement {...iconProps} />,
    AnnouncementOutlined: <AnnouncementOutlined {...iconProps} />,
    Replay: <Replay {...iconProps} />,
    CheckboxChecked: <CheckBox {...iconProps} />,
    RadioUnchecked: <RadioButtonUnchecked {...iconProps} />,
    RadioChecked: <RadioButtonChecked {...iconProps} />,
    PsychologyAlt: <PsychologyAlt {...iconProps} />,
    PsychologyAltOutlined: <PsychologyAltOutlined {...iconProps} />,
    TemporaryUsersOutlined: <SupervisedUserCircleOutlined {...iconProps} />,
    TemporaryUsers: <SupervisedUserCircle {...iconProps} />,
    Books: <Class {...iconProps} />,
    Calendar: <CalendarMonthOutlined {...iconProps} />,
    NotificationsOutlined: <NotificationsActiveOutlined {...iconProps} />,
    ArrowForward: <ArrowForward {...iconProps} />,
    ManageAccounts: <ManageAccounts {...iconProps} />,
    ManageAccountsOutlined: <ManageAccountsOutlined {...iconProps} />,
    Entity: <Category {...iconProps} />,
    EntityOutlined: <CategoryOutlined {...iconProps} />,
    Templates: <ViewQuilt {...iconProps} />,
    TemplatesOutlined: <ViewQuiltOutlined {...iconProps} />,
    Form: <DynamicForm {...iconProps} />,
    FormOutlined: <DynamicFormOutlined {...iconProps} />,
    Api: <Api {...iconProps} />,
    ApiOutlined: <ApiOutlined {...iconProps} />,
    Auditor: <SupervisedUserCircle {...iconProps} />,
    AuditorOutlined: <SupervisedUserCircleOutlined {...iconProps} />,
    Rule: <Rule {...iconProps} />,
    RuleOutlined: <RuleOutlined {...iconProps} />,
    KeyBoardArrowRight: <KeyboardArrowRight {...iconProps} />,
    KeyBoardArrowLeft: <KeyboardArrowLeft {...iconProps} />,
    ArrowRight: <ArrowRight {...iconProps} />,
    Dashboard: <Dashboard {...iconProps} />,
    DashboardOutlined: <DashboardOutlined {...iconProps} />,
    Subjects: <AutoStories {...iconProps} />,
    SubjectsOutlined: <AutoStoriesOutlined {...iconProps} />,
    Course: <CoPresent {...iconProps} />,
    CourseOutlined: <CoPresentOutlined {...iconProps} />,
    Subscriptions: <Subscriptions {...iconProps} />,
    SubscriptionsOutlined: <SubscriptionsOutlined {...iconProps} />,
    Badge: <Badge {...iconProps} />,
    BadgeOutlined: <BadgeOutlined {...iconProps} />,
    QuestionMark: <QuestionMark {...iconProps} />,
    QuestionMarkOutlined: <QuestionMarkOutlined {...iconProps} />,
    Discussions: <QuestionAnswer {...iconProps} />,
    DiscussionsOutlined: <QuestionAnswerOutlined {...iconProps} />,
    Category: <CategoryOutlined {...iconProps} />,
    Reply: <Reply {...iconProps} />,
    Like: <ThumbUp {...iconProps} />,
    LikeOutlined: <ThumbUpOutlined {...iconProps} />,
    Unlike: <ThumbDown {...iconProps} />,
    UnlikeOutlined: <ThumbDownOutlined {...iconProps} />,
    DropDown: <ArrowDropDown {...iconProps} />,
    DropUp: <ArrowDropUp {...iconProps} />,
    Send: <Send {...iconProps} />,
    Comment: <Comment {...iconProps} />,
    FilterAlt: <FilterAltRounded {...iconProps} />,
    FilterAltOff: <FilterAltOffRounded {...iconProps} />,
    Warning: <Warning {...iconProps} />,
    Filter: <Filter {...iconProps} />,
    DoNotDisturb: <DoNotDisturb {...iconProps} />,
    School: <School {...iconProps} />,
    SchoolOutlined: <SchoolOutlined {...iconProps} />,
    Stop: <Stop {...iconProps} />,
    AudioRecorder: <KeyboardVoice {...iconProps} />,
    ArrowBack: <ArrowBack {...iconProps} />,
    Checkbox: <CheckBoxOutlineBlank {...iconProps} />,
    Rows: <TableRows {...iconProps} />,
    AddBox: <AddBox {...iconProps} />,
    Settings: <Settings {...iconProps} />,
    SettingsOutlined: <SettingsOutlined {...iconProps} />,
    ArrowDownward: <ArrowDownward {...iconProps} />,
    ArrowUpward: <ArrowUpward {...iconProps} />,
    KeyboardArrowUp: <KeyboardArrowUp {...iconProps} />,
    ViewColumnRounded: <ViewColumnOutlined {...iconProps} />,
    // CONFLICT: shared/utilities.jsx used <AddCircleOutlineOutlined>, alive-academics/utilities.js
    // used <AddCircleOutline>. Kept the alive-academics value per the merge preference rule.
    AddCircleOutlined: <AddCircleOutline {...iconProps} />,
    AddCircleIcon: <AddCircle {...iconProps} />,
    DragIndicatorIcon: <DragIndicator {...iconProps} />,
    SplitScreen: <SplitscreenRounded {...iconProps} />,
    Protrait: <PortraitRounded {...iconProps} />,
    ProtraitOutlined: <PortraitOutlined {...iconProps} />,
    KeyboardArrowDownIcon: <KeyboardArrowDown {...iconProps} />,
    FullscreenIcon: <Fullscreen {...iconProps} />,
    FullscreenExitIcon: <FullscreenExit {...iconProps} />,
    VolumeOffIcon: <VolumeOff {...iconProps} />,
    VolumeDownIcon: <VolumeDown {...iconProps} />,
    VolumeUpIcon: <VolumeUp {...iconProps} />,
    PlayArrowIcon: <PlayArrow {...iconProps} />,
    PauseIcon: <Pause {...iconProps} />,
    Forward10Icon: <Forward10 {...iconProps} />,
    Replay10Icon: <Replay10 {...iconProps} />,
    InsightsIcon: <Insights {...iconProps} />,
    InsightsIconOutlined: <InsightsOutlined {...iconProps} />,
    GridViewIcon: <GridView {...iconProps} />,
    SegmentView: <Segment {...iconProps} />,
    ViewListIcon: <ViewList {...iconProps} />,
    LiveHelpIcon: <LiveHelp {...iconProps} />,
    LiveHelpIconOutlined: <LiveHelpOutlined {...iconProps} />,
    InsertDriveFileIcon: <InsertDriveFile {...iconProps} />,
    RemoveIcon: <Remove {...iconProps} />,
    DownloadingIcon: <Downloading {...iconProps} />,
    FolderIcon: <Folder {...iconProps} />,
    CheckIcon: <Check {...iconProps} />,
    QuizIcon: <Quiz {...iconProps} />,
    QuizIconOutlined: <QuizOutlined {...iconProps} />,
    RemoveCircleIcon: <RemoveCircle {...iconProps} />,
    NewReleasesIcon: <NewReleases {...iconProps} />,
    PlayCircleFilledWhiteIcon: <PlayCircleFilledWhite {...iconProps} />,
    PlayCircleFilledWhiteIconOutlined: <PlayCircleFilledWhiteOutlined {...iconProps} />,
    FiberManualRecordIcon: <FiberManualRecord {...iconProps} />,
    FiberManualRecordIconOutlined: <FiberManualRecordOutlined {...iconProps} />,
    UploadFileIcon: <UploadFile {...iconProps} />,
    EmojiPeopleIcon: <EmojiPeople {...iconProps} />,
    EmojiPeopleIconOutlined: <EmojiPeopleOutlined {...iconProps} />,
    ErrorIcon: <Error {...iconProps} />,
    ClearIcon: <Clear {...iconProps} />,
    BlockIcon: <Block {...iconProps} />,
    CheckCircleIcon: <CheckCircle {...iconProps} />,
    CheckCircleIconOutlined: <CheckCircleOutlined {...iconProps} />,
    EditIcon: <Edit {...iconProps} />,
    EditIconOutlined: <EditOutlined {...iconProps} />,
    AssignmentIcon: <Assignment {...iconProps} />,
    AssignmentIconOutlined: <AssignmentOutlined {...iconProps} />,
    DescriptionIcon: <Description {...iconProps} />,
    DescriptionIconOutlined: <DescriptionOutlined {...iconProps} />,
    DeviceHubIcon: <DeviceHub {...iconProps} />,
    PeopleAltIcon: <PeopleAlt {...iconProps} />,
    WcIcon: <Wc {...iconProps} />,
    SearchIcon: <Search {...iconProps} />,
    AddIcon: <Add {...iconProps} />,
    CodeIcon: <Code {...iconProps} />,
    BugReportIcon: <BugReport {...iconProps} />,
    ExpandLessIcon: <ExpandLess {...iconProps} />,
    ExpandMoreIcon: <ExpandMore {...iconProps} />,
    ExpandMoreComponent: ExpandMore,
    ExpandMore: ExpandMore,
    RateReviewIcon: <RateReview {...iconProps} />,
    DeleteIcon: <Delete {...iconProps} />,
    DeleteIconOutlined: <DeleteOutlined {...iconProps} />,
    VisibilityIcon: <Visibility {...iconProps} />,
    VisibilityOffIcon: <VisibilityOff {...iconProps} />,
    OndemandVideoIcon: <OndemandVideo {...iconProps} />,
    OndemandVideoIconOutlined: <OndemandVideoOutlined {...iconProps} />,
    FeedbackIcon: <Feedback {...iconProps} />,
    FeedbackIconOutlined: <FeedbackOutlined {...iconProps} />,
    HomeIcon: <Home {...iconProps} />,
    HomeIconOutlined: <HomeOutlined {...iconProps} />,
    DeveloperModeIcon: <DeveloperMode {...iconProps} />,
    DeveloperModeIconOutlined: <DeveloperModeOutlined {...iconProps} />,
    LockIcon: <Lock {...iconProps} />,
    LockIconOutlined: <LockOutlined {...iconProps} />,
    AnalyticsIcon: <Analytics {...iconProps} />,
    AnalyticsIconOutlined: <AnalyticsOutlined {...iconProps} />,
    CloseIcon: <Close {...iconProps} />,
    VideocamIcon: <Videocam {...iconProps} />,
    VideocamIconOutlined: <VideocamOutlined {...iconProps} />,
    ChevronLeftIcon: <ChevronLeft {...iconProps} />,
    ChevronRightIcon: <ChevronRight {...iconProps} />,
    CancelIcon: <Cancel {...iconProps} />,
    DownloadForOfflineIcon: <DownloadForOffline {...iconProps} />,
    DownloadIcon: <Download {...iconProps} />,
    DownloadIconOutlined: <DownloadOutlined {...iconProps} />,
    OpenInNewIcon: <OpenInNew {...iconProps} />,
    DeleteForever: <DeleteForever {...iconProps} />,
}

// Icons.small only existed in alive-academics/utils/utilities.js
Icons.small = {
    Checklist: <Checklist fontSize='small' {...iconProps} />,
    Selection: <HighlightAlt fontSize='small' {...iconProps} />,
    Badge: <Badge fontSize='small' {...iconProps} />,
    FullscreenExitIcon: <FullscreenExit fontSize='small' {...iconProps} />,
    FullscreenIcon: <Fullscreen fontSize='small' {...iconProps} />,
    Workspaces: <Workspaces fontSize='small' {...iconProps} />,
    // CancelReview: <DisabledVisible fontSize="small" {...iconProps} />,
    StopPresenting: <CancelPresentation fontSize='small' {...iconProps} />,
    Present: <PresentToAll fontSize='small' {...iconProps} />,
    Memory: <MemoryOutlined fontSize='small' {...iconProps} />,
    Clock: <AccessTime fontSize='small' {...iconProps} />,
    Settings: <SettingsOutlined fontSize='small' {...iconProps} />,
    ArrowBack: <ArrowBack fontSize='small' {...iconProps} />,
    Refresh: <Cached fontSize='small' {...iconProps} />,
    Groups: <Groups fontSize='small' {...iconProps} />,
    Groups2: <Groups2 fontSize='small' {...iconProps} />,
    Folder: <Folder fontSize='small' {...iconProps} />,
    FormatClear: <FormatClear fontSize='small' {...iconProps} />,
    KeyBoardArrowRight: <KeyboardArrowRight fontSize='small' {...iconProps} />,
    KeyBoardArrowLeft: <KeyboardArrowLeft fontSize='small' {...iconProps} />,
    GraphicEqRounded: <GraphicEqRounded fontSize='small' {...iconProps} />,
    KeyboardArrowUp: <KeyboardArrowUp {...iconProps} fontSize='small' />,
    SearchIcon: <Search {...iconProps} fontSize='small' />,
    ZoomIn: <ZoomIn {...iconProps} fontSize='small' />,
    ZoomOut: <ZoomOut {...iconProps} fontSize='small' />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined {...iconProps} fontSize='small' />,
    InfoIcon: <Info {...iconProps} fontSize='small' />,
    VisibilityIcon: <Visibility {...iconProps} fontSize='small' />,
    OpenInNewIcon: <OpenInNew {...iconProps} fontSize='small' />,
    CloseIcon: <Close {...iconProps} fontSize='small' />,
    Crown: <img src={CrownIcon} width='20px' alt='Crown small' />,
    Subject: <img width='20px' src={SubjectIcon} alt='Subject small' />,
    KeyboardArrowDown: <KeyboardArrowDown {...iconProps} fontSize='small' />,
    Category: <CategoryOutlined {...iconProps} fontSize='small' />,
    DropDown: <ArrowDropDown {...iconProps} fontSize='small' />,
    ChevronLeftIcon: <ChevronLeft {...iconProps} fontSize='small' />,
    ChevronRightIcon: <ChevronRight {...iconProps} fontSize='small' />,
    VolumeOffIcon: <VolumeOff {...iconProps} fontSize='small' />,
    VolumeDownIcon: <VolumeDown {...iconProps} fontSize='small' />,
    VolumeUpIcon: <VolumeUp {...iconProps} fontSize='small' />,
    DownloadIcon: <DownloadOutlined {...iconProps} fontSize='small' />,
    DeleteIcon: <DeleteOutlined {...iconProps} fontSize='small' />,
    EditIcon: <Edit {...iconProps} fontSize='small' />,
}
